import {combineLatest, Subject} from 'rxjs';
import {filter, map} from 'rxjs/operators';
import {wwData$} from '@/streams/worker-data';
import {contracts$} from '@/streams/config/contract';
import type {ContractPair, FromUiMsg} from '@px/ws-data';

export const tvSymbol$ = new Subject<string>();

// 根据指数/标记symbol查找相关交易对发送到worker处理K线精度问题
combineLatest([contracts$, tvSymbol$])
  .pipe(
    filter(([, symbol]) => !!symbol),
    map(([contracts, symbol]: [ContractPair[], string]) => contracts.find(({indexSymbol, markSymbol}) => [indexSymbol, markSymbol].includes(symbol))),
    filter(Boolean)
  )
  .subscribe(({symbol}) => wwData$.send({type: 'state-symbol', tradeType: 'Perpetual', symbol} as FromUiMsg));
